<!-- SPDX-License-Identifier: Apache-2.0 -->
<mat-sidenav-container>
  <mat-sidenav mode="side" opened class="sidenav width-s-hide">
    @for (link of navigation(); track link) {
      <ul
        class="entry"
        [ngClass]="{ selected: link.selected, expanded: link.expanded }"
      >
        <li>
          <span>
            @if (link.icon) {
              <mat-icon fontIcon="{{ link.icon }}" />
            }
            <b>
              <a [href]="link.href">
                {{ link.name.join("&#x200B;") }}
              </a>
            </b>
          </span>

          <ul>
            @for (child of link.children; track child) {
              <li
                class="entry"
                [ngClass]="{
                  selected: child.selected,
                  expanded: child.expanded,
                }"
              >
                <span>
                  <a [href]="child.href">
                    {{ child.name.join("&#x200B;") }}
                  </a>
                  @for (childTag of child.tags; track childTag) {
                    <span class="badge {{ childTag.type }}-badge">{{
                      childTag.value
                    }}</span>
                  }
                </span>

                <ul>
                  @for (subchild of child.children; track subchild) {
                    <li
                      class="entry"
                      [ngClass]="{
                        selected: subchild.selected,
                        expanded: subchild.expanded,
                      }"
                    >
                      <span>
                        <a [href]="subchild.href">
                          {{ subchild.name.join("&#x200B;") }}
                        </a>

                        @for (subChildTag of subchild.tags; track subChildTag) {
                          <span class="badge {{ subChildTag.type }}-badge">{{
                            subChildTag.value
                          }}</span>
                        }
                      </span>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </li>
      </ul>
    }
  </mat-sidenav>

  <mat-sidenav-content class="width-s-margin-reset">
    <div #scrollableElement style="overflow-y: auto; height: 100%">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
